<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear absolute color="success" height="4" indeterminate></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="deep-gl" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-tab>
        <v-spacer></v-spacer>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <v-form ref="fieldTagForm" v-model="validForm" @submit.prevent>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="requestData.value"
                      :label="`${$t('GENERAL.LABELS.NAME')} *`"
                      :rules="[validations.required()]"
                      :error-messages="validationErrors.value || []"
                      @change="clearValidationError('value')"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="back">{{ $t("GENERAL.LABELS.BACK_BUTTON") }}</v-btn>
              <v-btn color="success" @click="store">{{ actionText }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import validations from "@/views/partials/form/Validations.vue";
import { SHOW_SNACK } from "@/store/snack.module";
import userStateService from "@/common/userState.service.js";
import { GET_FIELD_TAG, STORE_FIELD_TAG, UPDATE_FIELD_TAG } from "@/store/fieldTags.module";

export default {
  name: "EditFieldTag",
  data() {
    return {
      validations,
      tab: "tab-1",
      isProcessing: false,
      validForm: false,
      validationErrors: {},
      title: "",
      actionText: this.$t("GENERAL.LABELS.CREATE_BUTTON"),
      requestData: {
        field_tag_type_id: null,
        value: "",
      },
    };
  },
  computed: {
    isEditMode() {
      return Boolean(this.$route.params.tagId);
    },
  },
  mounted() {
    this.title = this.$t("FIELD_TAGS.CREATE_TAG");
    this.requestData.field_tag_type_id = this.$route.params.fieldTagTypeId
      ? Number(this.$route.params.fieldTagTypeId)
      : null;
    this.loadFieldTag();
  },
  methods: {
    getErrorMessage(error) {
      if (error && error.errors && typeof error.errors === "object") {
        const firstErrorField = Object.keys(error.errors)[0];
        const firstErrorList = error.errors[firstErrorField];
        if (Array.isArray(firstErrorList) && firstErrorList.length) {
          return firstErrorList[0];
        }
      }
      if (error && error.message) {
        return error.message;
      }
      return this.$t("GENERAL.UNEXPECTED_ERROR");
    },
    setValidationErrors(error) {
      this.validationErrors = (error && error.errors) || {};
    },
    clearValidationError(field) {
      if (this.validationErrors[field]) {
        this.$delete(this.validationErrors, field);
      }
    },
    loadFieldTag() {
      if (!this.$route.params.tagId) {
        return;
      }

      this.title = this.$t("FIELD_TAGS.EDIT_TAG");
      this.actionText = this.$t("GENERAL.LABELS.EDIT_BUTTON");
      this.isProcessing = true;

      this.$store
        .dispatch(GET_FIELD_TAG, this.$route.params.tagId)
        .then((response) => {
          this.requestData = {
            field_tag_type_id: this.$route.params.fieldTagTypeId
              ? Number(this.$route.params.fieldTagTypeId)
              : null,
            value: response.value || "",
          };
        })
        .catch((error) => {
          this.$store.dispatch(SHOW_SNACK, { message: this.getErrorMessage(error), type: "error" });
          this.back();
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    back() {
      this.$router.push({ name: "field-tags", params: { fieldTagTypeId: this.$route.params.fieldTagTypeId } });
    },
    store() {
      this.$refs.fieldTagForm.validate();
      if (!this.validForm) {
        return;
      }

      this.validationErrors = {};
      const action = this.isEditMode ? UPDATE_FIELD_TAG : STORE_FIELD_TAG;
      const fixedFieldTagTypeId = this.$route.params.fieldTagTypeId
        ? Number(this.$route.params.fieldTagTypeId)
        : this.requestData.field_tag_type_id;
      const payload = this.isEditMode
        ? { id: this.$route.params.tagId, ...this.requestData, field_tag_type_id: fixedFieldTagTypeId }
        : { ...this.requestData, field_tag_type_id: fixedFieldTagTypeId };

      this.isProcessing = true;
      this.$store
        .dispatch(action, payload)
        .then((response) => {
          const blinkId = response?.id || this.$route.params.tagId;
          if (blinkId) {
            userStateService.setState("table-state.field-tags-table.blinkRowItemKey", blinkId);
          }

          this.$store.dispatch(SHOW_SNACK, { message: this.$t("GENERAL.SUCCESS_MESSAGE") });
          this.$router.push({
            name: "field-tags",
            params: { fieldTagTypeId: response.field_tag_type_id || this.requestData.field_tag_type_id },
          });
        })
        .catch((error) => {
          this.setValidationErrors(error);
          this.$store.dispatch(SHOW_SNACK, { message: this.getErrorMessage(error), type: "error" });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
